import { isRTLLocale } from '@wix/cashier-common/dist/src/utils/isRTLLocale';
import React, { Component } from 'react';
import { type IPayAppComponentProps } from '../../types/PayApp';
import NoPaymentMethodsUoU from './NoPaymentMethodsUoU/NoPaymentMethodsUoU';
import NoPaymentMethodUser from './NoPaymentMethodUser/NoPaymentMethodUser';
import s from './styles.scss';

export default class NoPaymentMethodContainer extends Component<IPayAppComponentProps, null> {
  closeWidget = () => {
    (window as any).Wix.closeWindow();
  };
  render() {
    const { viewMode } = this.props;
    return (
      <div
        className={s.root}
        data-hook="wcn-no-connected-payment-methods-container"
        dir={isRTLLocale(this.props.locale) ? 'rtl' : 'ltr'}
      >
        {viewMode === 'site' ? (
          <NoPaymentMethodsUoU onClickGotIt={this.closeWidget} siteOwnerEmail={'a'} />
        ) : (
          <NoPaymentMethodUser msid={this.props.msid} />
        )}
      </div>
    );
  }
}
